import React from "react";
import { useApp } from "../../contexts/AppContext";
import { TEMARIO } from "../../constants/temario";

const Quizzes = () => {
  const { setView, setCurrentExam, isPremium, navigateToProtectedFeature } =
    useApp();

  // Algoritmo de Fisher-Yates para barajar cualquier array
  const shuffleArray = (array) => {
    const newArr = [...array];
    for (let i = newArr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArr[i], newArr[j]] = [newArr[j], newArr[i]];
    }
    return newArr;
  };

  const handleStartQuiz = (topic) => {
    if (!isPremium) {
      navigateToProtectedFeature("practice");
      return;
    }

    console.log("Iniciando quiz aleatorio:", topic.title);

    // 1. Procesar preguntas: barajar opciones y recalcular índice correcto
    const randomizedQuestions = topic.questions.map((q) => {
      // Guardamos la respuesta correcta original mediante su índice
      const correctOptionText = q.o[q.c];

      // Barajamos las opciones
      const shuffledOptions = shuffleArray(q.o);

      // Encontramos el nuevo índice de la respuesta correcta
      const newCorrectIndex = shuffledOptions.indexOf(correctOptionText);

      return {
        ...q,
        o: shuffledOptions,
        c: newCorrectIndex,
        answered: false,
        selectedAnswer: null,
      };
    });

    // 2. Barajar el orden de las preguntas mismas
    const finalQuestions = shuffleArray(randomizedQuestions);

    const newExam = {
      title: topic.title,
      questions: finalQuestions,
      sourceId: topic.id,
      instanceId: Math.random(), // Forzamos una nueva instancia para React
      currentIdx: 0,
      score: 0,
      timer: 0,
    };

    console.log("Examen aleatorizado:", newExam);
    setCurrentExam(newExam);
    setView("exam");
  };

  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 animate-fade">
      {TEMARIO.map((topic) => (
        <div
          key={topic.id}
          onClick={() => handleStartQuiz(topic)}
          className="bg-white p-8 rounded-[2.5rem] card-shadow border border-slate-100 hover:border-blue-200 hover:shadow-xl transition-all cursor-pointer group relative overflow-hidden"
        >
          {!isPremium && (
            <div className="absolute top-6 right-6 text-slate-300">
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                />
              </svg>
            </div>
          )}

          <div className="text-4xl mb-4 group-hover:scale-110 transition-transform">
            {topic.icon}
          </div>
          <h4 className="font-black text-lg mb-2">{topic.title}</h4>
          <p className="text-slate-400 text-xs">
            {topic.questions.length}{" "}
            {topic.questions.length === 1 ? "pregunta" : "preguntas"} tipo
            examen
          </p>
          <div className="mt-4 text-blue-600 text-xs font-bold opacity-0 group-hover:opacity-100 transition-opacity">
            {isPremium ? "Click para comenzar →" : "Contenido Premium 🔒"}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Quizzes;
